import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryConfig } from '@/app/lib/tanstack-query';
import { getClientStatusLookups, getStateLookups } from '@/app/network/api';

export function getStateLookupsQueryOptions() {
  return queryOptions({
    queryKey: ['state-lookups'],
    queryFn: () => getStateLookups()
  });
}

export function useStateLookups({ queryConfig }: { queryConfig?: QueryConfig<typeof getStateLookupsQueryOptions> } = {}) {
  return useQuery({
    ...getStateLookupsQueryOptions(),
    ...queryConfig
  });
}

export function getClientStatusLookupsQueryOptions() {
  return queryOptions({
    queryKey: ['client-status-lookups'],
    queryFn: () => getClientStatusLookups()
  });
}

export function useClientStatusLookups({ queryConfig }: { queryConfig?: QueryConfig<typeof getClientStatusLookupsQueryOptions> } = {}) {
  return useQuery({
    ...getClientStatusLookupsQueryOptions(),
    ...queryConfig
  });
}
